/**
 * @fileoverview DELETE handler for the "/engagement/campaign/active_draft/:campaign_id" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { engagementCampaignActiveDraftCampaignIdCacheKeys } from "./constants";
import type {
  DeleteEngagementCampaignActiveDraftCampaignIdProps,
  EngagementCampaignActiveDraftCampaignIdResult,
} from "./types";

export const deleteEngagementCampaignActiveDraftCampaignId = reactQueryMutationAdapter(
  engagementCampaignActiveDraftCampaignIdCacheKeys,
  (
    props: DeleteEngagementCampaignActiveDraftCampaignIdProps
  ): Promise<EngagementCampaignActiveDraftCampaignIdResult> => {
    return fetch(
      `/engagement/campaign/active_draft/${props.campaignId}`,
      "DELETE",
      props,
      {},
      { propagateFetchRequestError: false }
    );
  }
);
